import { render, staticRenderFns } from "./DashboardReleaseNotes.vue?vue&type=template&id=89e8a4ae&scoped=true"
import script from "./DashboardReleaseNotes.vue?vue&type=script&lang=js"
export * from "./DashboardReleaseNotes.vue?vue&type=script&lang=js"
import style0 from "./DashboardReleaseNotes.vue?vue&type=style&index=0&id=89e8a4ae&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89e8a4ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89e8a4ae')) {
      api.createRecord('89e8a4ae', component.options)
    } else {
      api.reload('89e8a4ae', component.options)
    }
    module.hot.accept("./DashboardReleaseNotes.vue?vue&type=template&id=89e8a4ae&scoped=true", function () {
      api.rerender('89e8a4ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/DashboardReleaseNotes.vue"
export default component.exports